import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { StatCard, Badge, Spinner } from '../components/Common';
import { API_URL } from '../config';

const API = `${API_URL}/super-admin`;

const getToken = () => localStorage.getItem('bhamsa_sa_token');

const SuperAdminDashboard = () => {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/dashboard`, {
      headers: { Authorization: `Bearer ${getToken()}` }
    })
    .then(r => setData(r.data))
    .catch(() => toast.error('Dashboard load nahi hua'))
    .finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner />;

  const { stats, expiring_admins = [], recent_subscriptions = [] } = data || {};

  return (
    <div className="page">
      {expiring_admins.length > 0 && (
        <div className="low-stock-banner">
          ⚠️ <strong>{expiring_admins.length} admins</strong> ka plan 7 din mein expire hoga!
        </div>
      )}

      <div className="stats-grid gstr-grid">

        {/* Total Admins */}
        <div className="stats-container">
        <div className="stat-card stat-blue">
          <div className="icon">👥</div>
          <div className="details">
            <div className="value">
              {stats?.total_admins}
            </div>
            <div className="label">Total Admins</div>
            <div className="sub-text">
              Registered shops
            </div>
          </div>
        </div>

        {/* Active Admins */}
        <div className="stat-card stat-green">
          <div className="icon">✅</div>
          <div className="details">
            <div className="value">
              {stats?.active_admins}
            </div>
            <div className="label">Active Admins</div>
            <div className="sub-text">
              Active subscriptions
            </div>
          </div>
        </div>

        {/* Expired Admins */}
        <div className="stat-card stat-red">
          <div className="icon">❌</div>
          <div className="details">
            <div className="value">
              {stats?.expired_admins}
            </div>
            <div className="label">Expired Admins</div>
            <div className="sub-text">
              Renewal needed
            </div>
          </div>
        </div>

        {/* Total Revenue */}
        <div className="stat-card stat-orange">
          <div className="icon">💰</div>
          <div className="details">
            <div className="value">
              ₹{(stats?.total_revenue || 0).toLocaleString('en-IN')}
            </div>
            <div className="label">Total Revenue</div>
            <div className="sub-text">
              All time
            </div>
          </div>
        </div>

        </div>
        {/* <StatCard icon="👥" label="Total Admins"
          value={stats?.total_admins}
          sub="Registered shops"
          color="blue" />
        <StatCard icon="✅" label="Active Admins"
          value={stats?.active_admins}
          sub="Active subscriptions"
          color="green" />
        <StatCard icon="❌" label="Expired Admins"
          value={stats?.expired_admins}
          sub="Renewal needed"
          color="red" />
        <StatCard icon="💰" label="Total Revenue"
          value={`₹${(stats?.total_revenue||0).toLocaleString('en-IN')}`}
          sub="All time"
          color="orange" /> */}
      </div>

      <div className="two-col">
        {/* Expiring Soon */}
        <div className="card">
          <div className="card-header">
            <span className="card-title">⚠️ Expiring Soon (7 days)</span>
          </div>
          <div style={{ padding: 0 }}>
            {expiring_admins.length === 0 ? (
              <div style={{ padding: 24, textAlign: 'center', color: 'var(--text3)' }}>
                ✅ Koi expiry nahi aane wali
              </div>
            ) : (
              <table>
                <tbody>
                  {expiring_admins.map(a => (
                    <tr key={a.id}>
                      <td style={{ padding: '12px 16px' }}>
                        <div style={{ fontWeight: 600 }}>{a.shop_name}</div>
                        <div style={{ fontSize: 12, color: 'var(--text3)' }}>{a.name}</div>
                      </td>
                      <td style={{ padding: '12px 16px' }}>
                        <span style={{ color: 'var(--warn)', fontWeight: 600 }}>
                          {new Date(a.subscription_end_date).toLocaleDateString('en-IN')}
                        </span>
                      </td>
                      <td style={{ padding: '12px 16px' }}>
                        <Badge variant="orange">Expiring</Badge>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>

        {/* Recent Subscriptions */}
        <div className="card">
          <div className="card-header">
            <span className="card-title">🕐 Recent Subscriptions</span>
          </div>
          <div style={{ padding: 0 }}>
            {recent_subscriptions.length === 0 ? (
              <div style={{ padding: 24, textAlign: 'center', color: 'var(--text3)' }}>
                Koi subscriptions nahi
              </div>
            ) : (
              <table>
                <tbody>
                  {recent_subscriptions.map(s => (
                    <tr key={s.id}>
                      <td style={{ padding: '12px 16px' }}>
                        <div style={{ fontWeight: 600 }}>{s.user?.shop_name}</div>
                        <div style={{ fontSize: 12, color: 'var(--text3)' }}>
                          {s.invoice_number}
                        </div>
                      </td>
                      <td style={{ padding: '12px 16px', fontSize: 13 }}>
                        {s.plan?.name}
                      </td>
                      <td style={{ padding: '12px 16px', fontWeight: 700, color: 'var(--accent2)' }}>
                        ₹{parseFloat(s.amount_paid).toLocaleString('en-IN')}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminDashboard;